import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { ChatMessage } from 'src/app/cyn/chat-module/types/chat-session.types';
import {
    buildRegistryUrl,
    getRegistry,
    validateRegistryParams,
} from '../../../core/registries/registry-catalog';
import { AgentBlockComponent } from '../agent-block.base';

export interface RegistryLinkBlockPayload {
    registry: string;
    filters: Record<string, string | boolean | number>;
}

@Component({
    selector: 'chat-registry-link-block',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './chat-registry-link-block.component.html',
    styleUrls: ['./chat-registry-link-block.component.scss'],
})
export class ChatRegistryLinkBlockComponent
    extends AgentBlockComponent<'registry_link', RegistryLinkBlockPayload> {
    @Input() public override message!: ChatMessage<'registry_link', RegistryLinkBlockPayload>;

    public title = '';
    public appliedLabels: string[] = [];
    public route: string | null = null;

    public navigate(): void {
        if (this.route) {
            window.location.assign(this.route);
        }
    }

    /** @inheritdoc */
    protected override async validateBeforeRender(): Promise<boolean> {
        const registryId = this.message?.payload?.registry;
        const filters = this.message?.payload?.filters;

        if (typeof registryId !== 'string' || !registryId.trim()) {
            console.warn('Agent registry_link validation failed: missing registry');
            return false;
        }

        const registry = getRegistry(registryId.trim());

        if (!registry) {
            console.warn(`Agent registry_link validation failed: unknown registry=${registryId}`);
            return false;
        }

        const result = validateRegistryParams(registryId.trim(), filters);

        for (const error of result.errors) {
            console.warn(
                `Agent registry_link validation: key=${error.key}, reason=${error.reason}`,
                error.value !== undefined ? { value: error.value } : '',
            );
        }

        if (Object.keys(result.validParams).length === 0) {
            console.warn(
                `Agent registry_link validation failed: no valid filters for registry=${registryId}`,
            );
            return false;
        }

        const url = buildRegistryUrl(registryId.trim(), result.validParams);

        if (!url) {
            console.warn(`Agent registry_link validation failed: could not build url for registry=${registryId}`);
            return false;
        }

        this.title = registry.title;
        this.appliedLabels = result.appliedLabels;
        this.route = url;

        return true;
    }
}
